interface ICustomError {
  message: string | undefined;
  statusCode: number | string;
  errorCode: number | string;
  errorMessage: string;
  errorMetadata?: unknown;
}
class CustomError extends Error {
  statusCode: number | string;
  errorCode: number | string;
  errorMessage: string;
  errorMetadata?: unknown;
  constructor({
    message,
    statusCode,
    errorCode,
    errorMessage,
    errorMetadata,
  }: ICustomError) {
    super(message);
    this.name = 'ApiException';
    this.statusCode = statusCode;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.errorMetadata = errorMetadata;
  }
}

export default CustomError;
